import script from "./ModalMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMessage.vue?vue&type=script&setup=true&lang=js"

import "./ModalMessage.vue?vue&type=style&index=0&id=1acf23fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acf23fe"]])

export default __exports__